import { services } from '../services';
var action = "projectfloor";

export const projectfloorService = {
    getList,
    getListByProject,
    getOne,
    insert,
    update,
    remove
};

function getList(param = '') {
    return services.restApi('projectfloor' + param, 'GET');
}

function getListByProject(id, param = '') {

    param = services.appendIDParam({name: "project_floor", value: id}, param);
    return services.restApi(`${action}?page=0${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}